import React, { useState } from 'react'
import {
  ResponsiveContainer,
  XAxis,
  YAxis,
  CartesianGrid,
  AreaChart,
  Area,
  Tooltip
} from 'recharts'
import { ChartRange } from '../../constants/enum'
import TimeRangeSelector from './TimeRangeSelector'
import { toLpPriceString } from '../../utils/number'
import { toDateString, toTimeString } from '../../utils/string'
import LpPrice from '../../hooks/query/useLpPrice'

type Props = {
  asset: string
  vaultId: number
}

const CustomTooltip = ({ active, payload }: any) => {
  if (active && payload && payload.length) {
    return (
      <div className="text-white text-xs green-gradient rounded-lg p-1">
        <p>${toLpPriceString(payload[0].value)}</p>
      </div>
    )
  }
  return null
}

export default function LpPriceChart() {
  const [chartRange, setChartRange] = useState(ChartRange.Day)
  const lpPriceData = LpPrice(chartRange)

  return (
    <div>
      <div className="flex justify-between p-2 px-4">
        <p className="text-lg font-semibold text-green">LP Token Price</p>
        <TimeRangeSelector
          chartRange={chartRange}
          onSelect={(chartRange: ChartRange) => {
            setChartRange(chartRange)
          }}
        />
      </div>
      <div>
        {!lpPriceData ? (
          <div className="flex items-center justify-center h-60">
            <div className="animate-ping h-4 w-4 green-gradient rounded-full"></div>
          </div>
        ) : (
          <ResponsiveContainer width="100%" height={350}>
            <AreaChart data={lpPriceData}>
              <defs>
                <linearGradient
                  id="blueChartGradation"
                  x1="0%"
                  y1="0%"
                  x2="100%"
                  y2="100%"
                >
                  <stop offset="0%" stopColor="#5259FA1A" />
                  <stop offset="100%" stopColor="#5259FA00" />
                </linearGradient>
              </defs>
              <CartesianGrid stroke="#4c525f" />
              <XAxis
                dataKey="timestamp"
                tick={{ fontSize: 12 }}
                tickFormatter={timestamp =>
                  chartRange === ChartRange.Hour ||
                  chartRange === ChartRange.Day
                    ? toTimeString(timestamp)
                    : toDateString(timestamp)
                }
              />
              <YAxis
                dataKey="price"
                domain={['dataMin - 0.001', 'dataMax + 0.001']}
                tick={{ fontSize: 12 }}
                tickFormatter={(price: number) => `$${toLpPriceString(price)}`}
              />
              <Tooltip
                cursor={{ stroke: 'white', strokeWidth: 2, fill: 'none' }}
                content={<CustomTooltip />}
              />
              <Area
                type="monotone"
                dataKey="price"
                stroke="#257EFF"
                strokeWidth={2}
                fill="url(#blueChartGradation)"
                activeDot={{
                  r: 8,
                  stroke: 'white',
                  strokeWidth: 4,
                  fill: '#2E3239'
                }}
              />
            </AreaChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  )
}
